import React from "react"
import DOMPurify from "dompurify"

export interface TypographyProps {
    content?: string
}

export function Typography ({ content = "", ...props }: TypographyProps) {
    const htmlWithLinks = content
        .split("\n")
        .filter(row => row.trim() !== "")
        .map(row => `<p>${row.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#009DDE;font-size:15px;line-height:22px;text-decoration:underline;">$1</a>'
    )}</p>`)
        .join("");

    const clean = DOMPurify.sanitize(htmlWithLinks);
    return (
          <article
              className={"prose max-w-none prose-p:my-2 prose-ul:my-2"}
              dangerouslySetInnerHTML={{ __html: clean }}
              {...props}
          />
      )
  }
